import ScrollReveal from "@/components/feature/ScrollReveal";
import { whatsappUrl } from "@/utils/whatsapp";
import { WA_MESSAGES } from "@/mocks/site";
import { combos } from "@/mocks/menu";

export default function Combos() {
  return (
    <section id="combos" className="w-full bg-primary-500 py-16 text-background-50 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-10">
        <ScrollReveal className="max-w-3xl">
          <p className="text-xs font-medium uppercase tracking-[0.35em] text-primary-100">
            Combos
          </p>
          <h2 className="mt-4 font-heading text-4xl leading-[1.05] md:text-6xl">
            Combos con domicilio incluido
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-primary-100 md:text-lg">
            Sando + bebida + domicilio en un solo precio. Pide el combo del día por WhatsApp y te
            contamos qué hay hoy.
          </p>
          <a
            href={whatsappUrl(WA_MESSAGES.combos)}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex min-h-[52px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-8 text-base font-medium text-primary-600 transition-colors duration-300 hover:bg-background-100 sm:w-auto"
          >
            <i className="ri-whatsapp-line text-xl" aria-hidden="true" />
            Ver combos de hoy
          </a>
        </ScrollReveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:mt-16 md:grid-cols-3 md:gap-6">
          {combos.map((combo, index) => (
            <ScrollReveal key={combo.id} delay={index * 80}>
              <div className="flex h-full flex-col rounded-lg border border-dashed border-background-50/60 bg-primary-600/25 p-6 md:p-7">
                <span className="font-heading text-2xl">{combo.name}</span>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-primary-100">
                  {combo.includes}
                </p>
                <span className="mt-5 font-heading text-xl text-background-50">{combo.price}</span>
              </div>
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal className="mt-6">
          <p className="text-xs text-primary-100/90">
            Espacio reservado para los combos oficiales de la semana.
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
}